import moment from "moment-timezone";

const NumberFormat = () => {
	const twoDigits = (value) => {
		return value.toLocaleString("en-US", {
			minimumIntegerDigits: 2,
			useGrouping: false
		});
	};

	const withOrdinal = (value) => {
		return value !== null ? moment.localeData().ordinal(value) : "";
	};

	const isNumber = (a) => {
		return typeof a === "number" && !Number.isNaN(a);
	};

	const formatPeriod = (period, periodsInRegulation = 4) => {
		return period <= periodsInRegulation
			? withOrdinal(period).toUpperCase()
			: `OT${period - periodsInRegulation}`;
	};

	return {
		twoDigits,
		withOrdinal,
		isNumber,
		formatPeriod
	};
};

export default NumberFormat();
